export default __webpack_public_path__ + "static/media/Brow_1_C1.3c7808a0.svg";